import {
  Select,
  MenuItem,
  SelectChangeEvent,
  FormControl,
  InputLabel,
  Box,
  Avatar,
} from "@mui/material";
import React, { useState } from "react";

import i18n from "i18n";

type LanguageOption = {
  code: string;
  flagUrl: string;
};

const languages: LanguageOption[] = [
  { code: "it", flagUrl: "https://flagcdn.com/w40/it.png" },
  //{ code: "en", flagUrl: "https://flagcdn.com/w40/gb.png" },
  //{ code: "pl", flagUrl: "https://flagcdn.com/w40/pl.png" },
];

const LanguageSelector: React.FC = () => {
  const [language, setLanguage] = useState("it");

  const handleChange = (event: SelectChangeEvent) => {
    const newLang = event.target.value;
    setLanguage(newLang);
    i18n.changeLanguage(newLang);
  };

  const selectedLang = languages.find((lang) => lang.code === language);

  return (
    <FormControl fullWidth>
      <Select
        labelId="language-select-label"
        value={language}
        onChange={handleChange}
        sx={{ border: "unset", backgroundColor: "transparent!important" }}
        renderValue={() => (
          <Avatar
            src={selectedLang?.flagUrl}
            alt={selectedLang?.code}
            variant="square"
            sx={{ width: 32, height: 24 }}
          />
        )}
      >
        {languages.map((lang) => (
          <MenuItem key={lang.code} value={lang.code}>
            <Box display="flex" alignItems="center">
              <Avatar
                src={lang.flagUrl}
                alt={lang.code}
                variant="square"
                sx={{ width: 32, height: 24, mr: 1 }}
              />
              {lang.code.toUpperCase()}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSelector;
